module.exports = __webpack_public_path__ + "img/dp-dy-sy7.0.5db04937.png";